// import { ServiceProvider } from './../../providers/service/service';
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";
// import {
//   StreamingMedia,
//   StreamingVideoOptions,
// } from "@ionic-native/streaming-media";
import { VideoTutorialModalPage } from "../video-tutorial-modal/video-tutorial-modal";

@IonicPage()
@Component({
  selector: "page-manual-merchant",
  templateUrl: "manual-merchant.html",
})
export class ManualMerchantPage {
  merchant_no: any;
  round = 0;
  plaza = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage // private services: ServiceProvider, // private streamingMedia: StreamingMedia
  ) {
    this.storage.get("info").then((info) => {
      this.merchant_no = info.team.merchant_id;

      if (info.team.plaza_id == 1) {
        this.plaza = "A";
      } else if (info.team.plaza_id == 2) {
        this.plaza = "B";
      } else if (info.team.plaza_id == 3) {
        this.plaza = "C";
      } else if (info.team.plaza_id == 4) {
        this.plaza = "D";
      } else if (info.team.plaza_id == 5) {
        this.plaza = "E";
      } else if (info.team.plaza_id == 6) {
        this.plaza = "F";
      }
    });

    this.storage.get("roundGame").then((round) => {
      this.round = round;
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad ManualMerchantPage');
  }

  // rentSpace() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[26].video_url, options);
  //   });
  // }

  // checkStock() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[27].video_url, options);
  //   });
  // }

  // removeShop() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[28].video_url, options);
  //   });
  // }

  // refillStock() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[29].video_url, options);
  //   });
  // }

  // payRentalFee() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[30].video_url, options);
  //   });
  // }

  viewVdo(id) {
    this.storage.get("video").then((video) => {
      console.log("video===>", video);
      this.navCtrl.push(VideoTutorialModalPage, {
        id: id,
        vdo: video[id].video_url,
      });
    });
  }

  backPage() {
    this.navCtrl.push(MerchantHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/manual-merchant/manual-merchant.ts